import { apiPost, fetchForm, setFormSubmitButtonEnabled } from "./api";
import { Analytics } from "./analytics";
import { copyToClipboard } from "./util";

$(document).ready(function () {
    // Purchase tickets forms
    document.querySelectorAll('form[data-ticketing][name="voucher-form"]').forEach((form) => {
        const errorEle = form.querySelector('.form-error');

        form.addEventListener('submit', (event) => {
            event.preventDefault();
            errorEle.innerText = '';

            fetchForm(form).then((resp) => {
                Analytics.addBasketItems({
                    items: resp.itemAdditions, amount:  resp.itemAdditions.reduce((carry, item) => carry + item.price, 0)
                });

                window.location.href = '/cart';
            }).catch((err) => {
                errorEle.innerText = err?.response?.error ?? '';

                setFormSubmitButtonEnabled(form, true);
            });
        });
    });

    document.querySelectorAll('form[data-ticketing][name="basket-voucher-form"]').forEach((form) => {
        const errorEle = form.querySelector('.form-error');

        form.addEventListener('submit', (event) => {
            event.preventDefault();
            errorEle.innerText = '';

            fetchForm(form).then((resp) => {
                if (resp.itemRemovals.length) {
                    Analytics.removeBasketItems({
                        items: resp.itemRemovals,
                        amount:  resp.itemRemovals.reduce((carry, item) => carry + item.price, 0)
                    });
                }

                if (resp.itemAdditions.length) {
                    Analytics.addBasketItems({
                        items: resp.itemAdditions,
                        amount:  resp.itemAdditions.reduce((carry, item) => carry + item.price, 0)
                    });
                }

                window.location.href = '/cart';
            }).catch((err) => {
                errorEle.innerText = err?.response?.error ?? '';

                setFormSubmitButtonEnabled(form, true);
            });
        });
    });

    //todo: send to friendo
    document.querySelectorAll('form[data-ticketing][name="gift-voucher-form"]').forEach((giftForm) => {
        giftForm.addEventListener('submit', (event) => {
            event.preventDefault();

            fetchForm(giftForm).then((resp) => {
                window.location.reload();
            }).catch((err) => {
                setFormSubmitButtonEnabled(giftForm,true);
            });
        });
    });

    document.querySelectorAll('button[data-ticketing][name="openShareVoucher"]').forEach((giftFormshareVoucherButton) => {
        giftFormshareVoucherButton.addEventListener('click', () => {
            const form = giftFormshareVoucherButton.closest('form');
            form.querySelectorAll('.form-toggle-hidden').forEach((ele) => {
                ele.classList.toggle('hidden');
            });
        });
    });

    document.querySelectorAll('button[data-ticketing][name="copyVoucherCode"]').forEach((copyButton) => {
        let locked = 0
        copyButton.addEventListener('click', () => {
            const code = copyButton.getAttribute('data-code');
            copyToClipboard(code.replaceAll('_',' ')).then(
                () => {
                    // success
                    if (locked === 0) {
                        locked = 1;
                        let storedInnerHtml = copyButton.innerHTML;
                        copyButton.innerHTML = 'Copied to Clipboard!';
                        setTimeout(function() {
                            copyButton.innerHTML = storedInnerHtml;
                            locked = 0;
                        }, 3000);
                    }
                }
            )
        });
    });
});